import { OrganizationProfile } from "@clerk/clerk-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import {
  hasOrgAccess,
  useBillingStatus,
} from "../components/BillingStatusContext";
import { Header } from "../components/Header";
import { LoadingSpinner } from "../components/LoadingSpinner";

export const Route = createFileRoute("/organization")({
  component: OrganizationPage,
});

function OrganizationPage() {
  const navigate = useNavigate();
  const { billingStatus, isBillingLoading } = useBillingStatus();

  const hasOrganizationAccess = hasOrgAccess(billingStatus);

  useEffect(() => {
    if (!(isBillingLoading || hasOrganizationAccess)) {
      navigate({ to: "/" });
    }
  }, [hasOrganizationAccess, isBillingLoading, navigate]);

  if (isBillingLoading || !hasOrganizationAccess) {
    return (
      <div className="min-h-screen bg-[var(--bg-default)]">
        <Header currentPage="organization" />
        <main className="flex min-h-[calc(100vh-96px)] items-center justify-center px-6">
          <LoadingSpinner text="Loading organization..." size="md" />
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--bg-default)]">
      <Header currentPage="organization" />

      <main className="flex min-h-[calc(100vh-96px)] items-center justify-center px-6 py-8">
        <section>
          <div className="max-h-[calc(100vh-160px)] max-w-full overflow-auto rounded-[2rem]">
            <OrganizationProfile
              routing="hash"
              afterLeaveOrganizationUrl="/"
              fallback={
                <div className="flex min-h-64 items-center justify-center text-[var(--text-secondary)]">
                  Loading organization profile...
                </div>
              }
            />
          </div>
        </section>
      </main>
    </div>
  );
}
